export default "__VITE_ASSET__B2FTeS3n__"